module.exports = __webpack_public_path__ + "static/doctorManMobile-8794c0f1b7cefcf9a1aa31c5e324b1fd.png";